var Transfer = {
	transferNumAdult:null,
	transferNumChild:null,
	transferNumInfant:null,
	resultTable:$("#transferResultTable div.result-row")
};
	
var transferSearch = {
	searchAutoCompleteIdFrom:null,
	searchAutoCompleteIdTo:null,
	searchUrlFrom:null,
	searchUrlTo:null,
	fromDate:null,
	toDate:null
};

$.extend($.ui.menu.prototype.options, {
    items: "> :not(.ui-autocomplete-category)"
});

$(document).ready(function() {
	$('input[name="transferDate"]').daterangepicker({
	  singleDatePicker: true,
      minDate: moment(),
      minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  locale: {
	    format: 'DD.MM.YYYY'
	  }
	});
	$('input[name="returnDate"]').daterangepicker({
		singleDatePicker: true,
		startDate: moment().add(8, 'day'),
		minDate: moment(),
		minYear: 2022,
		maxYear: parseInt(moment().format('YYYY'),10),
		autoApply: true,
		autoUpdateInput: false,
		locale: {
		  format: 'DD.MM.YYYY'
		}
	  });
	$('#clearReturn').click(function() {
	  $('input[name="returnDate"]').val('');
	  $('#clearReturn').hide();
	});
	$('input[name="transferDate"]').on('apply.daterangepicker', function(ev, picker) {
		var minDate = picker.startDate;
		var returnPicker = $('input[name="returnDate"]').data('daterangepicker');
		var returnDate = returnPicker.startDate;
		returnPicker.minDate = minDate;
		
		if ($('input[name="returnDate"]').val().trim().length > 0 && returnDate.isBefore(minDate)) {
			$('input[name="returnDate"]').val(minDate.add(1,'days').format('DD.MM.YYYY'));
			returnPicker.setStartDate(minDate);
			returnPicker.setEndDate(minDate);
			departurePicker.setStartDate(minDate.add(-1,'days'));
		}
	});
	$('input[name="returnDate"]').on('apply.daterangepicker', function(ev, picker) {
	  $(this).val(picker.startDate.format('DD.MM.YYYY'));
	  $('#clearReturn').show();
	});
	
	$('input.trf-people-count').on('change',function(){
		var pax = 0;
		$('input.trf-people-count').each(function(idx,cbx){
			pax += parseInt($(cbx).val());
		});
		$('#trfPeople').val(pax + ' ' + FmtMessage.getMessage('js.passanger.type.traveler'));
	});
	
	$('#loading').modal({
		show : false
	});
	
	var forms = document.querySelectorAll('#transferSearchForm');

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
      .forEach(function (form) {
        form.addEventListener('submit', function (event) {
		  if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          } else {
          	form.classList.add('was-validated');
		  	$('#loading').modal('show');
		  }
        }, false)
    });
	
    var pageName = $('[name="pageName"]').val();
    if(pageName){
        pageName = pageName.replace("/","");
        if( window.location.pathname.substring(1) == pageName){
            parseCookieSearchValues();
        }
    }
	
	$.widget("custom.autocomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {
				if (item.category != currentCategory) {
					if (item.category == 1) {
						ul.append("<li class='ui-autocomplete-category iconCity' >" + FmtMessage.getMessage('js.result.city')  + "</li>");
					} else if (item.category == 4 || item.category == 3) {
						ul.append("<li class='ui-autocomplete-category iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					} else if (item.category == 2) {
						ul.append("<li class='ui-autocomplete-category iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");						
					} else if (item.category == 6) {
						ul.append("<li class='ui-autocomplete-category iconAirport' >" + FmtMessage.getMessage('js.result.airport') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li></li>")
    			.data("item.autocomplete", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    	}
	});
	
	var re = null;
	$(".transferAutoComplete").click(function(){ //,#retransferFrom, #retransferTo
        var selected = $(this).data("selected");
        if(!selected){
            $(this).select();
            $(this).data("selected", true);
        }
	}).focusout(function(){
        $(this).data("selected", false);
        var value = this.value;
        var label = $(this).data("label");
        if(label != value){
            this.value = "";
            $("#" + this.id + "Id").val("");
        }
	}).autocomplete({
		source : function(request, response) {
			var otherAutoComplete = $('#' + $(this.element).data('dir')).val();
			$.ajax({
				url : "/transfer/locations",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term,
					otherAutoCompleteId : otherAutoComplete
				},
				success : function(data) {
					
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					response($.map(data, function(item) {
						return {
							value: item.name,
							category : item.type,
							id: item.id
						};
						
					}));
				}
			});
		},
		minLength : 2,
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    },
		select : function(event, ui) {
			document.activeElement.blur();
			$(this).data("label", ui.item.value);
			$("#" + this.id + "Id").val(ui.item.id);
			$("#" + this.id + "Type").val(ui.item.category);
			
			if($(this).attr("tabindex") == 1){
				transferSearch.searchAutoCompleteIdFrom = ui.item.id;
				transferSearch.searchUrlFrom = ui.item.value;
			}
			else{
				transferSearch.searchAutoCompleteIdTo = ui.item.id;
				transferSearch.searchUrlTo = ui.item.value;
			}
		}
	});	
	
	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("item.autocomplete", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
	};
	
	$(".priceDetailButton").click(function(){
		var transferId = $(this).data("transferid");
		$("#selectedTransfer").val(transferId);
		
		var categoryId = $(this).data("categoryid");
		$("#selectedTransferCategory").val(categoryId);
		
		$('#loading').modal('show');
		$("#transferResult").submit();
		return true;
	});
	$( ".search-summary" ).click(function() {
	  $( ".change-search,.icon-search,.icon-close" ).toggleClass( "d-none" );
	  $(".modify-search").toggleClass( "btn-primary btn-danger" );
	});
	$('.placeholder-glow').hide();
});

function parseCookieSearchValues(){
	if($.cookie('transferSearchValues')){
		var searchData = JSON.parse($.cookie("transferSearchValues"));
		$('#fromLocationId').val(searchData.searchAutoCompleteIdFrom);
		$('#fromLocation').val(searchData.searchUrlFrom);
		
		$('#toLocationId').val(searchData.searchAutoCompleteIdTo);
		$('#toLocation').val(searchData.searchUrlTo);
		if(searchData.fromDate !=null){
			$('input[name="transferDate"]').val(searchData.fromDate);
		}
		if(searchData.toDate != null){
			$('input[name="returnDate"]').val(searchData.toDate);
			$("#clearReturn").show();
		}
	}
}

window.onbeforeunload = function (){
	var date = new Date();
	date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
	if($.cookie('transferSearchValues')){
		var searchData = JSON.parse($.cookie("transferSearchValues"));
		if(!transferSearch.searchAutoCompleteIdFrom){
			transferSearch.searchAutoCompleteIdFrom = searchData.searchAutoCompleteIdFrom;
			transferSearch.searchUrlFrom = searchData.searchUrlFrom;
			}
		if(!transferSearch.searchAutoCompleteIdTo){
			transferSearch.searchAutoCompleteIdTo = searchData.searchAutoCompleteIdTo;
			transferSearch.searchUrlTo = searchData.searchUrlTo;
		}
		if(!transferSearch.fromDate){
			transferSearch.fromDate = searchData.fromDate;
			}
		if(!transferSearch.toDate){
			transferSearch.toDate = searchData.toDate;
		}
	}
	
	if(transferSearch.searchAutoCompleteIdFrom != null){
		$.cookie('transferSearchValues',  JSON.stringify(transferSearch), { expires : date,  path : '/' });
	}
};